// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__1a5v_","tab":"ProcedureTabs_tab__3xLwy"};